export type ChecklistDocumentOptions = {
  autoCapitalize: "none" | "checklist-item" | "checklist-setting" | "both";
  includeSimOnlyWarning: boolean;
  includeAttributionInFooter: boolean;
};

export const defaultEditorOptions: ChecklistDocumentOptions = {
  autoCapitalize: "none",
  includeSimOnlyWarning: false,
  includeAttributionInFooter: false,
} as const;
